let activePlayback = null

export const claimLivePhotoPlayback = stopPlayback => {
  if (typeof stopPlayback !== 'function' || activePlayback === stopPlayback) {
    return
  }
  const previousPlayback = activePlayback
  activePlayback = stopPlayback
  previousPlayback?.()
}

export const releaseLivePhotoPlayback = stopPlayback => {
  if (activePlayback === stopPlayback) {
    activePlayback = null
  }
}

export const hasPointerMoved = (startX, startY, currentX, currentY, tolerance) => (
  Math.hypot(currentX - startX, currentY - startY) > tolerance
)

export const shouldInterruptLivePhotoTouch = state => (
  state !== 'loading' && state !== 'playing'
)

export const resolveLivePhotoExitTiming = (
  progress,
  zoomOutDuration,
  dissolveDuration,
  minimumDuration = 140
) => {
  const parsedProgress = Number(progress)
  const currentProgress = Number.isFinite(parsedProgress)
    ? Math.min(1, Math.max(0, parsedProgress))
    : 1
  const duration = Math.max(minimumDuration, zoomOutDuration * currentProgress)
  const currentDissolveDuration = Math.min(dissolveDuration, duration)
  return {
    duration,
    dissolveDuration: currentDissolveDuration,
    dissolveDelay: duration - currentDissolveDuration
  }
}

export const createLivePhotoRequestGuard = () => {
  let generation = 0
  return {
    begin: () => ++generation,
    cancel: () => {
      generation += 1
    },
    isCurrent: request => request === generation
  }
}

export const shouldStartLivePhotoAfterLoad = (pointerInside, hoverTimer) => (
  Boolean(pointerInside) && !hoverTimer
)
